import { Dispatch, SetStateAction, useEffect } from 'react';
import { Answer } from '../Poll.model';

export function useSimplePoll(
	simpleVoteCountUrl: string,
	liveVoteCountFetchSeconds: number,
	id: string,
	setAnswersState: Dispatch<SetStateAction<Answer[]>>,
	expired: boolean
) {
	useEffect(() => {
		const url = new URL(location.origin + simpleVoteCountUrl);
		url.searchParams.append('pollId', id);
		let timeout: ReturnType<typeof setTimeout>;
		async function fetchVotes() {
			if (!expired) {
				timeout = setTimeout(
					async () => {
						const response = await fetch(url);
						const voteCounts = (await response.json()) as number[];

						setAnswersState((prevState) => {
							const nextState = [...prevState];
							voteCounts.forEach((value, index) => {
								nextState[index].votes = value;
							});
							return nextState;
						});

						await fetchVotes();
					},
					liveVoteCountFetchSeconds ? liveVoteCountFetchSeconds * 1000 : 5000
				);
			}
		}
		fetchVotes();
		return () => {
			clearTimeout(timeout);
		};
	}, []);
}
